module.exports = __webpack_public_path__ + "slider3.jpg?e5a60b6729fc39ed940d4924b18e9ef4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/slider3.jpg
// module id = 123
// module chunks = 0